import { render, staticRenderFns } from "./phrase_drawer.vue?vue&type=template&id=15b5fd09&"
import script from "./phrase_drawer.vue?vue&type=script&lang=js&"
export * from "./phrase_drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports